import { insertSuggestNodeCommand } from "../../core/suggest/suggest";
import { SlashCommandGroup, } from "../../core/types";
const sampleTableJSON = {
    type: "table",
    content: [
        {
            type: "table_row",
            content: [
                {
                    type: "table_header",
                    content: [{ type: "paragraph" }],
                },
                {
                    type: "table_header",
                    content: [{ type: "paragraph" }],
                },
            ],
        },
        {
            type: "table_row",
            content: [
                {
                    type: "table_cell",
                    content: [
                        {
                            type: "paragraph",
                        },
                    ],
                },
                {
                    type: "table_cell",
                    content: [
                        {
                            type: "paragraph",
                        },
                    ],
                },
            ],
        },
    ],
};
export const tableCommandSpec = {
    label: `Insert Table`,
    description: `Insert a table`,
    group: SlashCommandGroup.Advanced,
    icon: "is-table",
    shortcut: "T",
    command: insertSuggestNodeCommand(sampleTableJSON, 2),
};
